const initialMailStatus = {
  mailResponseStatus: 0,
};

export default initialMailStatus;
